// utils/rangeSpeedTest.ts
export async function rangeTestMbps(
  url: string,
  bytes = 5 * 1024 * 1024,   // 5 MB
  timeoutMs = 15000
): Promise<number | null> {
  const ac = new AbortController();
  const t = setTimeout(() => ac.abort(), timeoutMs);
  try {
    const start = performance.now();
    const res = await fetch(`${url}?t=${Date.now()}`, {
      method: 'GET',
      headers: { Range: `bytes=0-${bytes - 1}` },
      cache: 'no-store',
      signal: ac.signal
    });
    if (!(res.status === 206 || res.status === 200) || !res.body) return null;

    const reader = res.body.getReader();
    let received = 0;
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      received += value?.byteLength || 0;
      if (received >= bytes) break; // stop early if server sent more
    }
    const secs = Math.max(0.001, (performance.now() - start) / 1000);
    const mbps = (received * 8) / secs / (1024 * 1024);
    return +mbps.toFixed(2);
  } catch {
    return null;
  } finally {
    clearTimeout(t);
  }
}
